(function ($) {
  const $snsslider = $('.customer_slide');
  $snsslider.slick({
    infinite: true,
    arrows: false,
    dots: true,
    autoplay: true,
    variableWidth: true,
    autoplaySpeed: 2000,
    centerMode: false
  });
})($224);
